import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FullContainer } from '../SharedComponents/FullContainer';
import { Routes } from '../_controllers/RouteController';
import { ModalXIconInverse } from '../images/images';
import { colors } from '../styles/colors';

const header = 'Free For Life Promotion';

const tosParagraphs = [
    `<p style="color: black; text-align: center !important; width: 100%; margin-top: -20px">“Free For Life” Promotion<br><b style="color: black;">Rules and Guidelines</b><br><br><b style="color: black;">PLEASE READ THESE RULES BEFORE ENTERING THE TIGHTKNIT</b>,
    <br><b style="color: black;">“FREE FOR LIFE” PROMOTION</b></p>`,
    ``,
    ``,
    `1.                  <b style="color: black;">General Information.</b> This Promotion is sponsored by TightKnit, Inc. <b style="color: black;">(“Sponsor”).</b>`,
    ``,
    `2.                  <b style="color: black;">Eligibility.</b> Promotion participants must be United States residents and at least 13 years of age at the time they register for the Promotion.`,
    ``,
    `By participating in this Promotion, participants accept and agree to be bound by these Rules and Guidelines, the TightKnit™ Terms of Use and Privacy Policy, and any decisions of Sponsor, which shall be final on all matters. `,
    ``,
    `3.                  <b style="color: black;">Promotion Period.</b> The Promotion is open to early adopters of the TightKnit platform and will run for a limited time as determined by Sponsor (the <b style="color: black;">“Promotion Period”</b>).`,
    ``,
    `4.                  <b style="color: black;">Registration.</b> Any eligible participant who signs up to join the TightKnit community at www.tightknit.com during the Promotion Period will receive free use of the TightKnit™ website, providing a place for you and your relatives to discover, enjoy and preserve the stories of your family, together, (the “TightKnit Platform”) for life.`,
    ``,
    `Sponsor is not responsible for any lost, misdirected, late, unsent, or incomplete registrations or for inaccurate information included in any registration, whether caused by the participant or by any equipment or programming associated with or utilized in this Promotion, or by any technical or human error that may occur in the transmittal of any registration or the processing of any function on the participant’s computer system. Any disputes regarding ownership of an account will be determined by Sponsor. Sponsor reserves the right, in its sole discretion, to disqualify any individual found to be tampering with the registration process or the operation of the Promotion; to be acting in violation of these rules; or to be acting with intent to annoy, abuse, threaten or harass any other person.`,
    ``,
    `5.                  <b style="color: black;">Limitations.</b> Eligible participants are granted access to the TightKnit Platform for life with the following exceptions:`,
    `(a)               Participants may be charged a license and/or any other applicable fees for future premium versions of the TightKnit Platform if they elect to subscribe to such versions;`,
    ``,
    `(b)               Participants may be charged a license and/or any other applicable fees for future product or service offerings, whether or not related to the TightKnit Platform, that may be provided by TightKnit directly or by a third party on a pass-through basis; and`,
    ``,
    `(c)               participants will be charged a monthly fee for any storage beyond 100GB.`,
    ``,

    `6.                  <b style="color: black;">Feedback.</b> In order to make improvements to the features and user experience of the TightKnit Platform, Sponsor may from time-to-time request feedback from participants. If a participant chooses to submit feedback or suggestions about the TightKnit Platform, Sponsor may use such feedback or suggestions without any restriction or obligation to compensate the participant and is under no obligation to keep feedback or suggestions confidential.`,

    ``,

    `7.                  <b style="color: black;">Disclaimers.</b> Participants are solely responsible for their own actions relating to this Promotion and their use of the TightKnit Platform. By participating in this Promotion, participants agree to release and hold harmless Sponsor and its officers, directors, employees and agents from and against any liability arising in connection with the Promotion.`,
    ``,
    `8.                  <b style="color: black;">Privacy.</b> Any information submitted by participants will be treated in accordance with TightKnit’s Privacy Policy. Entry in the Promotion constitutes consent to be added to Sponsor’s direct mail and internet marketing databases. Participants can opt-out of receiving such offers and emails at any time.`,
    ``,
    ``,
    ``,

    `<p style="text-align: center"><b style="color: black;">For additional information pertaining to the “Free for Life” Promotion or to request a copy, please contact Sponsor at info@tightknit.com.</b></p>`,
];

export class FreeForLifePromotion extends React.Component<RouteComponentProps<any>> {
    public onClickBack = () => {
        if (this.props.location.state && this.props.location.state.signupInfo) {
            const { email, firstName, lastName, password, acceptedTOS } = this.props.location.state.signupInfo;
            this.props.history.push(Routes.SIGNUP, {
                signupInfo: {
                    email: email || '',
                    firstName: firstName || '',
                    lastName: lastName || '',
                    password: password || '',
                    acceptedTOS: acceptedTOS || false,
                },
            });
        } else {
            this.props.history.push(Routes.SIGNUP);
        }
    }

    public render() {
        return (
            <FullContainer style={styles.backgroundColor}>
                <img onClick={() => this.onClickBack()} src={ModalXIconInverse} style={styles.exitButton} />
                <div style={styles.textContainer}>
                    <h1 style={styles.headerText}>{header}</h1>
                    {tosParagraphs.map((text, index) => {
                        return <p style={styles.bodyText} key={index} dangerouslySetInnerHTML={{ __html: text }} />;
                    })}
                </div>
            </FullContainer>
        );
    }
}

const styles = {
    bodyText: {
        width: 800,
        marginBottom: 15,
    },
    headerText: {
        paddingTop: 140,
        color: 'black',
        fontSize: 24,
        marginBottom: 40,
        textAlign: 'center',
    } as React.CSSProperties,
    textContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        paddingLeft: `calc(50vw - 250px)`,
        paddingRight: `calc(50vw - 250px)`,
        backgroundColor: '#F5F5F5',
    } as React.CSSProperties,
    exitButton: {
        height: 50,
        width: 50,
        borderRadius: 25,
        top: 30,
        right: 60,
        position: 'fixed',
        backgroundColor: colors.DARK_GREY,
    } as React.CSSProperties,
    backgroundColor: {
        backgroundColor: '#F5F5F5',
    },
};



// WEBPACK FOOTER //
// ./src/Pages/FreeForLife.tsx